module.exports = __webpack_public_path__ + "static/media/cart.4ea2fc69.svg";